@if (showIcon || hasResolvedColor || status || statusDateTime) {
  @let outerIconCls = 'ti-status--icon ti-status--outer-icon ' + icon;
  @let innerIconCls = 'ti-status--icon ti-status__chip--title ' + icon;
  @let showOuter = showIcon && outerIcon;
  @let showInner = showIcon && !outerIcon;

  <div class="ti-status ti-status__wrapper" [class.ti-status__fw]="fullView"
       kendoTooltip [tooltipTemplate]="tooltipTemplate" filter=".ti-status--icon"
       [showOn]="iconTooltipText ? 'hover' : 'none'">
    @if (showOuter && leftIcon) {
      <i aria-hidden="true" [class]="outerIconCls"></i>
    }
    <div class="ti-status__chip__substrate">
      <div class="ti-status__chip__wrapper {{chipViewClass || formatStatusToClass(status)}}"
           [style.--ti-status-color]="colorVar"
           [style.height.px]="blockHeight">
        @if (showInner && leftIcon) {
          <i aria-hidden="true" [class]="innerIconCls"></i>
        }
        <div class="ti-status__chip--title">{{ status }}</div>
        @if (showInner && !leftIcon) {
          <i aria-hidden="true" [class]="innerIconCls"></i>
        }
      </div>
    </div>
    @if (showOuter && !leftIcon) {
      <i aria-hidden="true" [class]="outerIconCls"></i>
    }
    <ng-template #tooltipTemplate>
      <span class="ti-status--tooltip-title">{{ iconTooltipText }}</span>
    </ng-template>
  </div>
}
@if (statusDateTime) {
  <div class="ti-status--date">{{ statusDateTime }}</div>
}
